import React, { useContext } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { useWeb3React } from '@web3-react/core'
import { useHamburger } from './HamburgerContext'

import {
  Logo,
  MintIcon,
  ProfileIcon,
  ProfileIconActive,
  RewardsIcon,
  RewardsIconActive,
  LeaderboardIcon,
  LeaderboardIconActive,
  VaultIconActive,
  MintIconActive,
  VaultIcon,
  FarmsIcon,
  FarmsIconActive,
  StakeIconActive,
  StakeIcon,
  ExchangeIcon,
  ExchangeIconActive,
  HelpIcon,
  DashboardIcon,
  DashboardIconActive,
} from 'src/assets/images'
import { SocialButton } from './SocialButton'

import { injected } from '../../constants/connectors'

import './Header.scss'
import { HamburgerButton } from './HamburgerButton'
import { formatAddress } from 'src/utils/format/formatAddress'
import { ArcContext } from 'src/contexts/ArcContext'
import ReactTooltip from 'react-tooltip'
import { CustomInfoTooltip } from '../CustomInfoTooltip'

export function Header() {
  const { account, activate, deactivate } = useWeb3React()
  const { isPlaynetActivated, setIsPlaynetActivated } = useContext(ArcContext)
  const { opened, close } = useHamburger()
  const baseTabs = [
    'Dashboard',
    'Mint',
    'Exchange',
    'Vaults',
    /* 'Savings' , */ 'Farms',
    'Leaderboard',
  ]
  const tabs = account ? [...baseTabs, 'Profile'] : baseTabs

  const stubify = (str) => `/${str.toLowerCase().split(' ').join('-')}`
  const pageName = useLocation().pathname
  const index = tabs.findIndex((t) => pageName.includes(stubify(t)))

  const tabNamesToImages = {
    Dashboard: { normal: DashboardIcon, active: DashboardIconActive },
    Mint: { normal: MintIcon, active: MintIconActive },
    Vaults: { normal: VaultIcon, active: VaultIconActive },
    Rewards: { normal: RewardsIcon, active: RewardsIconActive },
    Leaderboard: { normal: LeaderboardIcon, active: LeaderboardIconActive },
    Profile: { normal: ProfileIcon, active: ProfileIconActive },
    Farms: { normal: FarmsIcon, active: FarmsIconActive },
    Exchange: { normal: ExchangeIcon, active: ExchangeIconActive },
    Savings: { normal: StakeIcon, active: StakeIconActive },
  }

  const onConnectClicked = async () => {
    if (account) {
      localStorage.removeItem('user_connected')
      deactivate()
    } else {
      await activate(injected, (err) => console.error('activate', err))
      localStorage.setItem('user_connected', 'true')
    }
  }

  const onPlaynetToggleClicked = () => {
    setIsPlaynetActivated(!isPlaynetActivated)
  }

  return (
    <>
      <HamburgerButton />
      <div className={`header ${opened ? 'open' : ''}`}>
        <div className="header__container">
          <div style={{ width: '100%' }}>
            <div className="header__account-items">
              <Link to="/" style={{ outline: 'none' }}>
                <img className="header__logo" src={Logo} alt="logo" />
              </Link>
              <div className="header__account-info">
                {account ? (
                  <p className="header__address-label">{formatAddress(account, 4)}</p>
                ) : null}

                <div className="header__connect" onClick={onConnectClicked}>
                  {account ? 'Disconnect' : 'Connect Wallet'}
                </div>
              </div>
            </div>
            <div className="header__menu-items">
              {tabs.map((t, i) => (
                <Link
                  onClick={close}
                  to={stubify(t)}
                  className={`header__menu-item ${
                    i === index ? 'header__menu-item--active' : 'header__menu-item'
                  }`}
                  key={i}
                >
                  <img
                    className="header__menu-item-img"
                    alt=""
                    src={i === index ? tabNamesToImages[t].active : tabNamesToImages[t].normal}
                  />
                  {t}
                </Link>
              ))}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://wiki.arcx.money/"
                className="header__menu-item"
              >
                <img className="header__menu-item-img" alt="" src={HelpIcon} />
                Help/Wiki
              </a>
            </div>
          </div>
          <div>
            <div className="header__social-buttons">
              <SocialButton icon="discord" url="https://discord.gg/skwz6je" />
              <SocialButton icon="twitter" url="https://twitter.com/arcxmoney" />
            </div>
            <div className="header__playnet-container">
              <button className="header__playnet-toggle-btn" onClick={onPlaynetToggleClicked}>
                Switch to {isPlaynetActivated ? 'Mainnet' : 'Playnet'}
              </button>
              <div
                className={`header__playnet-status ${
                  isPlaynetActivated && 'header__playnet-status--playnet'
                }`}
              />
              <div className="header__playnet-info">
                <ReactTooltip multiline id="playnet" />
                <CustomInfoTooltip
                  forId="playnet"
                  place="top"
                  description={
                    '"Playnet" is a testing environment on mainnet. Only useful for the developers.'
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
